import {styled, TextField} from '@mui/material';

const StyledIconImage = styled('img')`
	height: 80px;
	margin-top: 8px;
	width: 80px;
`;

const StyledInput = styled(TextField)`
	width: 42px;

	& > .MuiInputBase-root {
		border-radius: 4px;
		height: 46px;
	}

	& > .MuiInputBase-root > .MuiInputBase-input {
		box-sizing: border-box;
		height: 100%;
		padding: 0;
		text-align: center;

		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		&[type='number'] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
	}
`;

export {StyledIconImage, StyledInput};
